<ptg-bulk-update 
    [name]="importKey" 
    target="Metadata"
    [targetType]="metadataKey" 
    [fileTypes]="supportedFiles"
></ptg-bulk-update>